import { getLocaleName, listAvailableLocales } from "@/locales";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { IconTheme } from "./IconButton/IconButton";
import { IconMenu } from "./IconButton/IconMenu";
import { IconMenuButton } from "./IconButton/IconMenuButton";
import { useNavigateToLocale } from "../locales";
import styles from "./LangSelection.module.scss";
import { metrics } from "../analytics/events";
export function LangSelection() {
    var intl = useIntl();
    var navigateToLocale = useNavigateToLocale();
    var availableLocales = useMemo(function () { return listAvailableLocales(); }, []);
    return (React.createElement(IconMenu, { theme: IconTheme.Dark, arrow: true, iconSize: "large", trigger: "hover", onToggle: function (visible) {
            if (visible) {
                metrics.clickOnLanguageSelector();
            }
        }, icon: require("@/public_assets/button_language.png"), iconHover: require("@/public_assets/button_language_hover.png"), menu: {
            theme: "dark",
            content: function (close) { return (React.createElement("div", { className: styles.selectorMenu }, availableLocales.map(function (locale) { return (React.createElement(IconMenuButton, { key: locale, onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    metrics.onLanguageSelected(locale);
                    navigateToLocale(locale);
                    close();
                }, active: locale === intl.locale }, getLocaleName(locale))); }))); },
            position: "bottom-left",
            size: "medium",
        } }));
}
